import { getTranslationDateType } from './useTimelineEventDescription'

export default function residenceTranslationInfo(ancestor, year, location, ageAtEvent) {
  const ancestorName = ancestor.name ? ancestor.name : ancestor.surname

  // t translation parameters
  return [
    generateTranslationStringName(ancestor, year, location, ageAtEvent),
    {
      ancestorName: `${ancestorName}`,
      date: `${year}`,
      location: `${location}`,
      age: `${ageAtEvent}`,
      defaultValue: ``,
    },
  ]
}

function generateTranslationStringName(ancestor, year, location, ageAtEvent) {
  const gender =
    ancestor && ancestor.gender !== 'male' && ancestor.gender !== 'female' ? 'genderunknown' : ancestor.gender
  const date = getTranslationDateType(year)
  const place = location !== '' ? '.in.location' : ''
  const age = ageAtEvent !== '' ? '.age' : ''
  const noInfo = date === '' && place === '' && age === '' ? '.no-info' : ''

  return `wcf.person-timeline.residence${noInfo}${date}${place}${age}.gender-${gender}`
}
